module.exports = __webpack_public_path__ + "static/media/hosting-image.778afe70.png";